import { baseBUCGet } from '../base/baseBUC';

const str = '';
const decimal = 0.00;
const dateTimeStr = new Date()?.toISOString();

export const apartmentReceiptPaymentModelGet = ({
    buildingId = str,
    apartmentId = str,
    receiptId = str,
    apartmentReceiptId = str,
    paymentMethodId = str,
    bankId = str,
    bankOriginId = str,
    bankAccountId = str,
    userId = str,
}) => {
    return {
        //buildingId: buildingId,
        apartmentId: apartmentId,
        receiptId: receiptId,
        apartmentReceiptId: apartmentReceiptId,
        paymentMethodId: paymentMethodId,
        bankId: bankId,
        bankOriginId: bankOriginId,
        bankAccountId: bankAccountId,
        collectionCashId: str,
        //userId: userId,
        amount: decimal,
        conciliationUserId: str,
        concilationDate: dateTimeStr,
        conciliationRemark: str,
        concilationStatus: str,
        //created: dateTimeStr,
        date: dateTimeStr,
        reference: str,
        ...baseBUCGet({ buildingId: buildingId, userId: userId, }),
    }
};